import { useState, useRef, useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";

const DashboardFilters = ({
    filterBy, setFilterBy,
    filterDatesBy, setFilterDatesBy,
    filters, setFilters,
    services, zones,
    handleService, handleZone
}) => {
    const [isOpenServices, setIsOpenServices] = useState(false);
    const [searchTermServices, setSearchTermServices] = useState("");
    const servicesRef = useRef(null);

    const [isOpenZones, setIsOpenZones] = useState(false);
    const [searchTermZones, setSearchTermZones] = useState("");
    const zonesRef = useRef(null);

    // Close dropdowns on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (servicesRef.current && !servicesRef.current.contains(event.target)) {
                setIsOpenServices(false);
            }
            if (zonesRef.current && !zonesRef.current.contains(event.target)) {
                setIsOpenZones(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Services calculations
    const selectedServicesCount = filters.serviceIds?.length || 0;
    const totalServicesCount = services?.length || 0;
    const isAllServicesSelected = totalServicesCount > 0 && selectedServicesCount === totalServicesCount;

    let buttonServicesText = "";
    if (selectedServicesCount === 0) {
        buttonServicesText = "Seleccionar servicios...";
    } else if (isAllServicesSelected) {
        buttonServicesText = `Todos los servicios (${totalServicesCount})`;
    } else {
        buttonServicesText = `${selectedServicesCount} de ${totalServicesCount} servicios`;
    }

    const filteredServices = services?.filter(service => 
        service?.name?.toLowerCase().includes(searchTermServices.toLowerCase())
    ) || [];

    // Zones calculations
    const selectedZonesCount = filters.zoneIds?.length || 0;
    const totalZonesCount = zones?.length || 0;
    const isAllZonesSelected = totalZonesCount > 0 && selectedZonesCount === totalZonesCount;

    let buttonZonesText = "";
    if (selectedZonesCount === 0) {
        buttonZonesText = "Seleccionar zonas...";
    } else if (isAllZonesSelected) {
        buttonZonesText = `Todas las zonas (${totalZonesCount})`;
    } else {
        buttonZonesText = `${selectedZonesCount} de ${totalZonesCount} zonas`;
    }

    const filteredZones = zones?.filter(zone => 
        zone?.name?.toLowerCase().includes(searchTermZones.toLowerCase())
    ) || [];

    return (
        <div className="row">
            <div className="col-md-6">
                <div className="card p-3">
                    <Tabs
                        activeKey={filterBy}
                        onSelect={(k) => setFilterBy(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="services" title="Servicios">
                            {
                                filterBy === 'services' ?
                                    services?.length > 1 ?
                                        <div className="form-group position-relative">
                                            <div className="custom-multiselect" ref={servicesRef}>
                                                <button 
                                                    type="button" 
                                                    className="form-control text-left d-flex justify-content-between align-items-center"
                                                    onClick={() => setIsOpenServices(!isOpenServices)}
                                                    style={{
                                                        background: '#fff',
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '4px',
                                                        padding: '0.375rem 0.75rem',
                                                        width: '100%',
                                                        cursor: 'pointer',
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    <span className="text-truncate mr-2">{buttonServicesText}</span>
                                                    <i className={`fa fa-chevron-${isOpenServices ? 'up' : 'down'} text-muted`} style={{ fontSize: '12px' }}></i>
                                                </button>

                                                {isOpenServices && (
                                                    <div 
                                                        className="dropdown-menu show p-2"
                                                        style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            zIndex: 1000,
                                                            maxHeight: '320px',
                                                            overflowY: 'auto',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            border: '1px solid #e2e8f0',
                                                            borderRadius: '6px',
                                                            background: '#fff',
                                                            marginTop: '4px'
                                                        }}
                                                    >
                                                        {/* Search Input */}
                                                        <div className="mb-2">
                                                            <input 
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                placeholder="Buscar servicio..."
                                                                value={searchTermServices}
                                                                onChange={(e) => setSearchTermServices(e.target.value)}
                                                                style={{ borderRadius: '4px' }}
                                                            />
                                                        </div>

                                                        {/* Checkbox "Select All" / "Todos" */}
                                                        <div 
                                                            className="dropdown-item d-flex align-items-center py-1 px-2 mb-1 rounded" 
                                                            style={{ cursor: 'pointer', background: '#f8fafc', fontWeight: 'bold' }}
                                                            onClick={() => {
                                                                setFilters(old => ({
                                                                    ...old,
                                                                    serviceIds: isAllServicesSelected ? [] : services.map(s => s.id)
                                                                }));
                                                            }}
                                                        >
                                                            <input 
                                                                type="checkbox" 
                                                                className="mr-2"
                                                                checked={isAllServicesSelected}
                                                                readOnly
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <span>Seleccionar Todos</span>
                                                        </div>

                                                        <div style={{ borderBottom: '1px solid #edf2f7', margin: '4px 0' }}></div>

                                                        {/* Scrollable list of services */}
                                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }} className="custom-chart-scrollbar">
                                                            {filteredServices.length > 0 ? (
                                                                filteredServices.map((service, i) => {
                                                                    const isChecked = filters.serviceIds?.includes(service.id);
                                                                    return (
                                                                        <div 
                                                                            key={i}
                                                                            className="dropdown-item d-flex align-items-center py-1 px-2 rounded" 
                                                                            style={{ 
                                                                                cursor: 'pointer',
                                                                                backgroundColor: isChecked ? '#f0f7ff' : 'transparent'
                                                                            }}
                                                                            onClick={() => {
                                                                                setFilters(old => {
                                                                                    const alreadySelected = old.serviceIds.includes(service.id);
                                                                                    const newIds = alreadySelected 
                                                                                        ? old.serviceIds.filter(id => id !== service.id)
                                                                                        : [...old.serviceIds, service.id];
                                                                                    return { ...old, serviceIds: newIds };
                                                                                });
                                                                            }}
                                                                        >
                                                                            <input 
                                                                                type="checkbox" 
                                                                                className="mr-2"
                                                                                checked={isChecked}
                                                                                readOnly
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                            <span className="text-truncate" style={{ fontSize: '14px' }}>
                                                                                {service?.name}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div className="text-muted text-center py-2" style={{ fontSize: '13px' }}>
                                                                    No se encontraron servicios
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        :
                                        <h4>
                                            {services?.[0]?.name}
                                        </h4>
                                    :
                                    null
                            }
                        </Tab>
                        <Tab eventKey="zones" title="Zonas">
                            {
                                filterBy === 'zones' ?
                                    zones?.length > 1 ?
                                        <div className="form-group position-relative">
                                            <div className="custom-multiselect" ref={zonesRef}>
                                                <button 
                                                    type="button" 
                                                    className="form-control text-left d-flex justify-content-between align-items-center"
                                                    onClick={() => setIsOpenZones(!isOpenZones)}
                                                    style={{
                                                        background: '#fff',
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '4px',
                                                        padding: '0.375rem 0.75rem',
                                                        width: '100%',
                                                        cursor: 'pointer',
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    <span className="text-truncate mr-2">{buttonZonesText}</span>
                                                    <i className={`fa fa-chevron-${isOpenZones ? 'up' : 'down'} text-muted`} style={{ fontSize: '12px' }}></i>
                                                </button>

                                                {isOpenZones && (
                                                    <div 
                                                        className="dropdown-menu show p-2"
                                                        style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            right: 0,
                                                            zIndex: 1000,
                                                            maxHeight: '320px',
                                                            overflowY: 'auto',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            border: '1px solid #e2e8f0',
                                                            borderRadius: '6px',
                                                            background: '#fff',
                                                            marginTop: '4px'
                                                        }}
                                                    >
                                                        {/* Search Input */}
                                                        <div className="mb-2">
                                                            <input 
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                placeholder="Buscar zona..."
                                                                value={searchTermZones}
                                                                onChange={(e) => setSearchTermZones(e.target.value)}
                                                                style={{ borderRadius: '4px' }}
                                                            />
                                                        </div>

                                                        {/* Checkbox "Select All" / "Todas" */}
                                                        <div 
                                                            className="dropdown-item d-flex align-items-center py-1 px-2 mb-1 rounded" 
                                                            style={{ cursor: 'pointer', background: '#f8fafc', fontWeight: 'bold' }}
                                                            onClick={() => {
                                                                setFilters(old => ({
                                                                    ...old,
                                                                    zoneIds: isAllZonesSelected ? [] : zones.map(z => z.id)
                                                                }));
                                                            }}
                                                        >
                                                            <input 
                                                                type="checkbox" 
                                                                className="mr-2"
                                                                checked={isAllZonesSelected}
                                                                readOnly
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                            <span>Seleccionar Todas</span>
                                                        </div>

                                                        <div style={{ borderBottom: '1px solid #edf2f7', margin: '4px 0' }}></div>

                                                        {/* Scrollable list of zones */}
                                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }} className="custom-chart-scrollbar">
                                                            {filteredZones.length > 0 ? (
                                                                filteredZones.map((zone, i) => {
                                                                    const isChecked = filters.zoneIds?.includes(zone.id);
                                                                    return (
                                                                        <div 
                                                                            key={i}
                                                                            className="dropdown-item d-flex align-items-center py-1 px-2 rounded" 
                                                                            style={{ 
                                                                                cursor: 'pointer',
                                                                                backgroundColor: isChecked ? '#f0f7ff' : 'transparent'
                                                                            }}
                                                                            onClick={() => {
                                                                                setFilters(old => {
                                                                                    const alreadySelected = old.zoneIds.includes(zone.id);
                                                                                    const newIds = alreadySelected 
                                                                                        ? old.zoneIds.filter(id => id !== zone.id)
                                                                                        : [...old.zoneIds, zone.id];
                                                                                    return { ...old, zoneIds: newIds };
                                                                                });
                                                                            }}
                                                                        >
                                                                            <input 
                                                                                type="checkbox" 
                                                                                className="mr-2"
                                                                                checked={isChecked}
                                                                                readOnly
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                            <span className="text-truncate" style={{ fontSize: '14px' }}>
                                                                                {zone?.name}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div className="text-muted text-center py-2" style={{ fontSize: '13px' }}>
                                                                    No se encontraron zonas
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        :
                                        <h4>
                                            {zones?.[0]?.name}
                                        </h4>
                                    :
                                    null
                            }
                        </Tab>
                    </Tabs>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card p-3">
                    <Tabs
                        activeKey={filterDatesBy}
                        onSelect={(k) => setFilterDatesBy(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="month" title="Mes y año">
                            <label>Mes y Año</label>
                            <input
                                type="month"
                                id="start"
                                name="start"
                                className="form-control"
                                value={filters?.monthAndYear}
                                onChange={(e) => setFilters((oldFilters) => {
                                    return {
                                        ...oldFilters,
                                        monthAndYear: e.target.value
                                    }
                                })}
                            />
                        </Tab>
                        <Tab eventKey="dates" title="Rango de fechas">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Desde</label>
                                    <input
                                        type="date"
                                        id="start"
                                        name="start"
                                        className="form-control"
                                        value={filters?.start}
                                        onChange={(e) => setFilters((oldFilters) => {
                                            return {
                                                ...oldFilters,
                                                start: e.target.value
                                            }
                                        })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>Hasta</label>
                                    <input
                                        type="date"
                                        id="end"
                                        name="end"
                                        className="form-control"
                                        value={filters?.end}
                                        onChange={(e) => setFilters((oldFilters) => {
                                            return {
                                                ...oldFilters,
                                                end: e.target.value
                                            }
                                        })}
                                    />
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
            <style dangerouslySetInnerHTML={{__html: `
                .custom-multiselect .dropdown-item {
                    transition: background-color 0.15s ease;
                }
                .custom-multiselect .dropdown-item:hover {
                    background-color: #f1f5f9 !important;
                }
                .custom-multiselect .dropdown-item:active {
                    background-color: #e2e8f0 !important;
                }
            `}} />
        </div>
    );
};

export default DashboardFilters;
